import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { motion } from "framer-motion";

const NewsPage = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000/api';

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const response = await axios.get(`${BACKEND_URL}/news`);
                setNews(response.data);
            } catch (err) {
                setError('Failed to fetch news');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchNews();
    }, [BACKEND_URL]);

    return (
        <div className="max-w-5xl mx-auto py-8 px-4">
            <h1 className="text-3xl font-bold text-center mb-6">Latest News</h1>
            {error && <p className="text-red-500 text-center">{error}</p>}
            {loading ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className="h-60 w-full bg-gray-200 animate-pulse rounded-lg"></div>
                    ))}
                </div>
            ) : news.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {news.map((article, index) => (
                        <motion.div
                            key={index}
                            whileHover={{ scale: 1.05 }}
                            className="cursor-pointer"
                        >
                            <div 
                                onClick={() => window.open(article.url, '_blank')} 
                                className="overflow-hidden shadow-lg rounded-2xl bg-white border border-gray-300 hover:shadow-xl transition p-4"
                            >
                                <img src={article.image} alt={article.title} className="w-full h-40 object-cover rounded-lg" />
                                <div className="p-4">
                                    <h2 className="text-lg font-semibold mb-2">{article.title}</h2>
                                    <button className="text-blue-500 underline">Read More</button>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            ) : (
                <p className="text-center">No news available.</p>
            )}
        </div>
    );
};

export default NewsPage;
